import { render, staticRenderFns } from "./ClientDetailCard.vue?vue&type=template&id=5836970c&scoped=true"
import script from "./ClientDetailCard.vue?vue&type=script&lang=js"
export * from "./ClientDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836970c",
  null
  
)

export default component.exports